/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/committeList.config.json";
import member from "../config/memberDetail.config.json";
import analytics from "../config/analyticsWidget.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_COMMITTE_LIST, GET_PRESENTATIONS } from "../graphql";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICommitteListMethods extends IPluginMethodMap {
  getcommitteListProps(args: any): Promise<any>;
}

export class CommitteListService implements IAgentPlugin {
  readonly methods: ICommitteListMethods;

  constructor() {
    this.methods = {
      getcommitteListProps: this.getcommitteListProps.bind(this),
    };
  }

  async getcommitteListProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args==>", args?.criteria?.presentation);
    const _filter = {};
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        console.log(_res?.data?.getPresentations?.content);
        const activeItem = _res?.data?.getPresentations?.content.find(
          (item: any) => item.status === "active"
        );
        const defaultPresentation = args?.criteria?.presentation
          ? args?.criteria?.presentation
          : activeItem && activeItem?.id
            ? activeItem?.id
            : null;
        // const defaultPresentation = _res?.data?.getPresentations?.content[0]?.id;
        console.log("defaultPresentation", defaultPresentation);
        if (defaultPresentation === null) {
          throw new Error("Presentation not found");
        }
        let searchType: any = "";
        let filterMulti;
        if (args?.criteria) {
          searchType = this.determineSearchType(args?.criteria);
        }
        if (searchType === "multi") {
          filterMulti = this.getMultiFilter(args?.criteria);
        }
        let filter: any = {};
        if (args?.criteria?.fullName) {
          filter = {
            ...filter,
            firstName: {
              contains: args?.criteria?.fullName,
            },
          };
        }
        if (args?.criteria?.email) {
          filter = {
            ...filter,
            email: {
              contains: args?.criteria?.email,
            },
          };
        }
        if (args?.criteria?.accountStatus__in) {
          filter = {
            ...filter,
            accountStatus: {
              eq: args?.criteria?.accountStatus__in,
            },
          };
        }
        if (searchType === "multi") {
          filter = filterMulti.reduce(
            (acc, { changedCol, value, changedOP }) => {
              acc[changedCol] = {
                [changedOP]: value,
              };
              return acc;
            },
            {}
          );
        }
        if (
          args?.criteria?.presentation &&
          args?.criteria?.presentation === "all"
        ) {
          filter = {
            ...filter,
            // Invites___presentation: {
            //   eq: args?.criteria?.presentation,
            // },
          };
        }
        if (
          args?.criteria?.presentation &&
          args?.criteria?.presentation !== "all"
        ) {
          filter = {
            ...filter,
            Invites___presentation: {
              eq: args?.criteria?.presentation,
            },
          };
        }
        if (!args?.criteria?.presentation && defaultPresentation) {
          filter = {
            ...filter,
            Invites___presentation: {
              eq: defaultPresentation,
            },
          };
        }

        console.log(filter);
        let presentationOptions: any = [];
        presentationOptions = _res?.data?.getPresentations?.content?.map(
          (_item: any) => {
            return { value: _item?.id, label: _item?.name, year: _item?.year };
          }
        );
        // console.log();
        const res = await client.query({
          query: GET_COMMITTE_LIST,
          variables: {
            filter: filter,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let result = res?.data?.getAllCommitteInviteStatus?.content;
          const rows = this.formatUserTable(result);
          let _totalPages = res?.data?.getAllCommitteInviteStatus?.count
            ? Math.ceil(
              parseInt(res?.data?.getAllCommitteInviteStatus?.count) / 10
            )
            : 1;

          let _currentPage =
            res?.data?.getAllCommitteInviteStatus?.skip /
            res?.data?.getAllCommitteInviteStatus?.limit +
            1;
          return {
            ...config,
            ...member,
            ultUsers: rows,
            isEmpty:
              res?.data?.getAllCommitteInviteStatus?.content?.length <= 0,
            currentPage: _currentPage,
            activePage: _currentPage,
            pageSize: _currentPage * rows.length,
            totalCount: res?.data?.getAllCommitteInviteStatus?.count,
            totalPages: _totalPages,
            searchPresentationFilter: presentationOptions,
            defaultPresentation: defaultPresentation,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    return { ...(config || {}) };
  }

  private formatUserTable(result: any) {
    let rows: any[] = [];
    result.forEach((item?: any) => {
      console.log(item);
      let user = {
        id: item?.id ?? "-",
        firstName: item?.firstName ?? "",
        surname: item?.lastName ?? "",
        fullName: item?.firstName
          ? item?.lastName
            ? item?.firstName + " " + item?.lastName
            : item?.lastName
          : item?.lastName
            ? item?.lastName
            : item?.email,
        email: item?.email ?? "",
        vuid: item?.vuid,
        accountStatus: item?.accountStatus,
        invitedBy:
          item?.Invites[0]?.invitedBy?.fullName ??
          item?.Invites[0]?.invitedBy?.email ??
          "-",
      };
      let maxInvites = 0,
        purchased = 0,
        referalsUsed = 0,
        remaining = 0;
      item?.Invites.forEach((invite?: any) => {
        (maxInvites += invite?.maxInvites),
          (purchased += invite?.purchased),
          (referalsUsed += invite?.referalsUsed);
      });
      remaining = (maxInvites ?? 0) - (referalsUsed ?? 0);
      let userInvite = {
        maxInvites: maxInvites,
        purchased: purchased,
        inviteUsed: referalsUsed,
        remaining: remaining,
      };
      rows.push({
        ...user,
        ...userInvite,
      });
    });
    return rows;
  }

  private getMultiFilter(criteria: any) {
    const options = [
      {
        label: "Masquerader",
        value: "fe93dab0-424b-4aa3-9efa-c001b4c04444",
      },
      {
        label: "Admin",
        value: "fe93dab0-424b-4aa3-9efa-c001b4c03013",
      },
      {
        label: "committeeMember",
        value: "99403c8b-abc1-4796-b61f-78e0c4022792",
      },
      {
        label: "cashier",
        value: "f5bebfee-dc0a-460a-9a3f-c6cde8fed944",
      },
      {
        label: "supervisor",
        value: "ca9521c7-d584-43b8-8c90-79aa3e11bddc",
      },
      {
        label: "cashSupervisor",
        value: "5dbff659-66e4-4a66-b03c-f9b2d3dd6de6",
      },
    ];

    const transformedCriteria: any = [];
    Object.values(criteria).forEach((item: any) => {
      const column = item.filters.inputData.id;
      const op = item.filters.inputData.label;

      // Determine the value based on the available filter keys
      let value = "";
      if (column === "role" && "Equal" in item.filters) {
        const label = item.filters.Equal;
        const option = options.find((opt) => opt.label === label);
        if (option) {
          value = option.value.toLowerCase();
        }
      } else if ("Contains" in item.filters) {
        value = item.filters.Contains.toLowerCase();
      } else if ("Equal" in item.filters) {
        value = item.filters.Equal.toLowerCase();
      } // Add more conditions for other possible filter keys
      let changedOP = op === "Equal" ? "eq" : "contains";
      console.log(column);
      let changedCol;
      if (column == "email") {
        changedCol = "email";
      }
      if (column == "role") {
        changedCol = "role";
      }
      if (column == "fullName") {
        changedCol = "firstName";
      }
      transformedCriteria.push({
        changedCol,
        value,
        changedOP,
      });
    });

    return transformedCriteria;
  }
  private determineSearchType(criteria: any) {
    if (Object.keys(criteria)[0] === "0") {
      return "multi";
    } else {
      return "normal";
    }
  }
}
